import React from 'react';
import { Quote } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  author: string;
  position: string;
}
export default function TestimonialCard({
  quote,
  author,
  position
}: TestimonialCardProps) {
  return <div className="bg-white rounded-lg shadow-md p-6 h-full flex flex-col card-lift hover:border-l-4 hover:border-secondary transition-all" data-id="element-487" data-mp="nnq2t49hkqr2">
      <div className="text-secondary mb-4 transform transition-transform hover:scale-110" data-id="element-488" data-mp="1gbvmrospubpu">
        <Quote className="h-8 w-8" data-id="element-489" data-mp="1bcsiw7oh2bjg" />
      </div>
      <p className="text-slate-dark italic mb-6 flex-grow leading-relaxed" data-id="element-490" data-mp="1be3mo7hx3jak">
        {quote}
      </p>
      <div className="border-t border-gray-200 pt-4" data-id="element-491" data-mp="16kra4vqij2y6">
        <p className="font-bold text-primary" data-id="element-492" data-mp="11n90120rehol">{author}</p>
        <p className="text-slate text-sm" data-id="element-493" data-mp="11mfz4hohemed">{position}</p>
      </div>
    </div>;
}